import { createRoot } from 'react-dom/client';
import useStore from './components/_store'

import Modal from '@/react/libraries/Modal';
import delegate from '@/components/delegate';
import { useEffect, useRef, useState } from 'react';

import CurrentSelectionInfo from './components/_CurrentSelectionInfo';
import HuntUserList from './components/_HuntUserList'; 


const Page = ({ payload }) => {
	const { fkDataTable } = payload
	// store
	const currentHuntUsers = useStore((state) => state.currentHuntUsers)
	const setCurrentHuntUsers = useStore((state) => state.setCurrentHuntUsers)
	const setTotalRO = useStore((state) => state.setTotalRO)
	const setUnassignedRO = useStore((state) => state.setUnassignedRO)
	const selectedHuntUsers = useStore((state) => state.selectedHuntUsers)
	const resetSelectedHuntUsers = useStore((state) => state.resetSelectedHuntUsers)
	const setJurisdictionName = useStore((state) => state.setJurisdictionName)

	// state
	const [modalType, setModalType] = useState('')
	const [modalContent, setModalContent] = useState(null)
	const [checkSummary, setCheckSummary] = useState(null)
	const [country, setCountry] = useState(null)
	const [state, setState] = useState(null)

	// refs
	const modalRef = useRef(null)
	const statusButtonRef = useRef(null)
	const jurisdictionDropdownRef = useRef(null)
	const huntUserListRef = useRef(null)

	const resetStore = () => {
		setCountry(null)
		setState(null)
		setCurrentHuntUsers(null)
		setTotalRO(0)
		setUnassignedRO(0)
		setJurisdictionName('Select a jurisdiction')
	}

	const fetchData = async (url) => {
		if (huntUserListRef.current) huntUserListRef.current.setIsLoading(true)

		let res = await axios.get(url, {
			headers: window.HEADER_OBJ
		})

		if (huntUserListRef.current) huntUserListRef.current.setIsLoading(false)

		let data = res.data

		if (!data.status) {
			return
		}

		data = data.data
		setCurrentHuntUsers(data.users)
		setTotalRO(data.count)
		setUnassignedRO(data.assigned_count ? data.count - data.assigned_count : data.count)
		setJurisdictionName(data.jurisdiction_name)
	}

	const handleAssign = async (e) => {
		const payload = {
			users: []
		}

		if (country) payload.country_id = country
		if (state) payload.state_id = state

		// compare initial users and selected users
		payload.users = currentHuntUsers.map(u => {
			// compare the counts, if there's a difference, add to payload
			let selectedUser = selectedHuntUsers.find(su => su.id == u.id)
			if (selectedUser && selectedUser.quantity != u.hunt_count) {
				return {
					id: selectedUser.id,
					quantity: selectedUser.quantity
				}
			}
		}).filter(u => u)

		if (payload.users.length == 0) {
			toast.error('Please make some changes.')
			return
		}

		try {
			window.__.loaderButtonInit(e.target)
			const response = await axios.post(`${BASE_URL}admin/hunt/assign`, payload, {
				headers: window.HEADER_OBJ
			})

			if (!response.data.status) {
				toast.error(response.data.message)
				return
			}

			toast.success(response.data.message)

			// refresh the table
			if (fkDataTable) {
				fkDataTable.searchDt()
			}
		} catch (error) {
			if (error.response) {
				let data = error.response.data
				toast.error(data.message)
				return
			} else {
				toast.error('Something went wrong. Please try again later.')
				return
			}
		} finally {
			modalRef.current.closeModal()
			e.target.finishLoading()
		}
	}

	const initDropdown = async () => {
		jurisdictionDropdownRef.current = await window.initROCountryMultiLayer('#jurisdictionDropdown')
		document.querySelector('#jurisdictionDropdown').addEventListener('itemSelect', async (e) => {
			resetStore()
			const detail = e.detail
			let param;
			if (detail.key === 'country') {
				setCountry(detail.value)
				param = `country_id=${detail.value}`
			} else if (detail.key === 'state') {
				setState(detail.value)
				param = `state_id=${detail.value}`
			}

			await fetchData(`${BASE_URL}admin/hunt/assign-status-data?${param}`)
		})
	}

	const handleModalClose = () => {
		setModalType('')
		setCheckSummary(null)
		resetSelectedHuntUsers()
		resetStore()
	}

	useEffect(() => {
		delegate({
			selector: 'button[data-modal]',
			event: 'click',
			handler: async (element, event) => {
				if (element.dataset.type === 'check') {
					event.preventDefault()
					event.stopPropagation()
					const fkUploadId = element.dataset.fkUploadId
					if (!fkUploadId) {
						toast.error('Missing upload ID')
						return
					}
					try {
						const response = await axios.get(
							`${BASE_URL}admin/hunt/check-status/${encodeURIComponent(fkUploadId)}`,
							{ headers: window.HEADER_OBJ },
						)
						if (!response.data?.status) {
							toast.error(response.data?.message || 'No data found')
							return
						}
						const summary = response.data.data
						setCheckSummary(summary)
						setModalType('check')
						setTimeout(() => modalRef.current?.openModal(), 0)
					} catch (error) {
						if (error.response?.data?.message) {
							toast.error(error.response.data.message)
						} else {
							toast.error('Something went wrong. Please try again later.')
						}
					}
					return
				}

				setCheckSummary(null)
				setModalType('assign')
				resetStore()

				modalRef.current.openModal()
				modalRef.current.setIsLoading(true)
				let param = ``

				if (element.dataset.countryId) {
					setCountry(element.dataset.countryId)
					param += `country_id=${element.dataset.countryId}&`
				}

				if (element.dataset.stateId) {
					setState(element.dataset.stateId)
					param += `state_id=${element.dataset.stateId}`
				}

				await fetchData(`${BASE_URL}admin/hunt/assign-hunt-data?${param}`)
				modalRef.current.setIsLoading(false)
			}
		});
	}, [])

	useEffect(() => {
		if (modalType === 'assign') {
			setModalContent(<h2>Assign Uploads</h2>)
		} else if (modalType === 'status') {
			setModalContent(
				<>
					<h2>Assignment Status</h2>
				</>,
			)
		} else if (modalType === 'check') {
			setModalContent(<h2>Assignment summary</h2>)
		}
	}, [modalType])

	useEffect(() => {
		if (modalType === 'status') {
			initDropdown()
		}
	}, [modalContent])

	return <>
		<button
			className='btn btn-wide'
			ref={statusButtonRef}
			onClick={() => {
				setCheckSummary(null)
				setModalType('status')
			}}
		>
			Assignment Status
		</button>

		<Modal modalTriggerRef={statusButtonRef} ref={modalRef} className='modal__content-wrapper p-2' onClose={handleModalClose}>
			<div className='modal__content-wrapper-header'>
				<div className='flex-grow flex flex-col gap-4'>
					{modalContent}
				</div>

			</div>
			<div className="modal__content-wrapper-body">
				{modalType === 'check' && checkSummary ? (
					<div className="flex flex-col gap-4 text-sm">
						<dl className="m-0 grid grid-cols-[auto_1fr] gap-x-4 gap-y-2">
							<dt className="m-0 font-semibold ">Upload ID</dt>
							<dd className="m-0">{checkSummary.fk_upload_id ?? '—'}</dd>
							<dt className="m-0 font-semibold">Total links</dt>
							<dd className="m-0">{checkSummary.total ?? '—'}</dd>
						</dl>
						{checkSummary.stage_counts && (
							<div>
								<p className="m-0 mb-2 font-semibold">By links</p>
								<ul className="m-0 list-none space-y-1 p-0">
									{Object.entries(checkSummary.stage_counts).map(([stage, count]) => (
										<li key={stage} className="flex justify-between gap-4 border-b border-gray-100 py-1 last:border-0">
											<span className="capitalize text-gray-700">{stage.replace(/_/g, ' ')}</span>
											<span className="font-medium tabular-nums">{count}</span>
										</li>
									))}
								</ul>
							</div>
						)}
					</div>
				) : (
					<>
						<div className='flex gap-4 items-start'>
							{modalType === 'status' && (
								<div id='jurisdictionDropdown' className='w-full' data-multi-select="false"></div>
							)}
							<CurrentSelectionInfo className='min-w-[30%] ml-auto' />
						</div>
						<HuntUserList ref={huntUserListRef} />
					</>
				)}
			</div>
			<div className="modal__content-wrapper-footer">
				{modalType === 'check' ? (
					<button type="button" className="btn btn-wide" onClick={() => modalRef.current?.closeModal()}>
						Close
					</button>
				) : (
					<button className='btn btn-wide' id='assignButton' onClick={handleAssign}>
						Assign
					</button>
				)}
			</div>
		</Modal>
	</>
}



function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;